export default __webpack_public_path__ + "static/media/music-icon.819c1e51.png";